import LayoutProvider from "../../../../providers/LayoutProvider";
import React from "react";
import Chart from 'react-apexcharts';
import 'apexcharts';
import { Link, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { getChart, getUserStats } from "../../../../components/Axios/Axios";

function UserStats() {
    const { id }: any = useParams();
    const [totalHours, setTotalHours] = React.useState("");
    const [day, setDay] = React.useState("")
    const [night, setNight] = React.useState("")
    const [pic, setPic] = React.useState("")
    const [sic, setSic] = React.useState("")
    const [crossCountry, setCrossCountry] = React.useState("")
    const [dualRecv, setDualRecv] = React.useState("")
    const [groundSim, setGroundSim] = React.useState("")
    const [totalFlights, setTotalFlights] = React.useState("")
    const [landingDay, setLandingDay] = React.useState("")
    const [landingNight, setLandingNight] = React.useState("")
    const [totalAircrafts, setTotalAircrafts] = React.useState("")
    const [monthlyFlightsData, setMonthlyFlightsData] = React.useState([]);



    const [chartOptions, setChartOptions] = React.useState({
        chart: {
          id: 'bar-chart',
          toolbar: {
            show: true,
          },
    
          dataLabels: {
            enabled: false,
          },
    
        },
        colors: ['#00af80'],
    
        dataLabels: {
          enabled: false,
        },
    
        plotOptions: {
          bar: {
            columnWidth: 20, // Set your desired width here
          },
        },
    
      });

    const fetchStats = async () => {

        try {
            const data = await getChart(id);
             setMonthlyFlightsData(data?.data || " ");
             const data2=await getUserStats(id);
              setTotalHours(data2?.flight.model[0]?.total?.toFixed(2) || 0);
              setDay(data2?.flight.model[0]?.day?.toFixed(2) || 0);
              setNight(data2?.flight.model[0]?.night?.toFixed(2) || 0)
              setPic(data2?.flight.model[0]?.pic || 0)
              setSic(data2?.flight.model[0]?.sic || 0)
              setCrossCountry(data2?.flight.model[0]?.xc?.toFixed(2) || 0)
              setLandingDay(data2?.flight.model[0]?.dayLDGS || 0)
              setLandingNight(data2?.flight.model[0]?.nightLDGS || 0)
              setGroundSim(data2?.flight.model[0]?.simInst?.toFixed(2) || 0)
              setDualRecv(data2?.flight.model[0]?.dualReceived?.toFixed(2) || 0)
              setTotalFlights(data2?.totalFlight || 0)
              setTotalAircrafts(data2?.totalAircraft || 0);
        }
        catch (error) {
            console.error("Error Fetching Chart", error);
        }

    }

    React.useEffect(() => {
        fetchStats();
    }, []);



    return (
        <LayoutProvider>
            <h6 className="dashboard_subheading">Dashboard {">"} User Stats</h6>
            <section
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                }}
            >
                <h4 className="dashboard_heading">User Stats</h4>
            </section>
            <section className="map_section">
                <section>
                    <h4 className="heading-4">Month Flight Progress</h4>
                    {monthlyFlightsData && <Chart
                        options={{
                            ...chartOptions,
                            xaxis: {
                                categories: Object.keys(monthlyFlightsData),
                            },
                        }}
                        series={[
                            {
                                name: 'Flights',
                                data: Object.values(monthlyFlightsData),
                            },
                        ]}
                        type="bar"
                        height={400}
                    />}
                </section>
                <section>
                    <h4 className="heading-4">Quick Report</h4>
                    <div className="report_row">
                        <div className="report_box">
                            <p>Total Flights</p>
                            <h3>{totalFlights}</h3>
                        </div>
                        <div className="report_box">
                            <p>Total Aircrafts</p>
                            <h3>{totalAircrafts}</h3>
                        </div>
                        <div className="report_box">
                            <p>Dual Received</p>
                            <h3>{dualRecv}</h3>
                        </div>
                    </div>
                    <div className="report_row">
                        <div className="report_box">
                            <p>Total Hours</p>
                            <h3>{totalHours}</h3>
                        </div>
                        <div className="report_box">
                            <p>Day</p>
                            <h3>{day}</h3>
                        </div>
                        <div className="report_box">
                            <p>Night</p>
                            <h3>{night}</h3>
                        </div>
                    </div>
                    <div className="report_row">
                        <div className="report_box">
                            <p>Pilot In Command</p>
                            <h3>{pic}</h3>
                        </div>
                        <div className="report_box">
                            <p>Second In Command</p>
                            <h3>{sic}</h3>
                        </div>
                        <div className="report_box">
                            <p>Ground Simulator</p>
                            <h3>{groundSim}</h3>
                        </div>
                    </div>
                    <div className="report_row">
                        <div className="report_box">
                            <p>Day Landing</p>
                            <h3>{landingDay}</h3>
                        </div>
                        <div className="report_box">
                            <p>Night Landing</p>
                            <h3>{landingNight}</h3>
                        </div>
                        <div className="report_box">
                            <p>Cross County</p>
                            <h3>{crossCountry}</h3>
                        </div>
                    </div>
                </section>
            </section>




        </LayoutProvider >
    );
}

export default UserStats;